import statistics from "../admin/companies/one/statistics";
export default statistics;